<template>
  <div class="visit-page">
    <h1>展覽資訊 Exhibition Information</h1>
    
    <div class="locations">
      <div class="location-item">
        <h3>拱廳</h3>
        <div class="content-row">
          <div class="image-container">
            <img src="@/assets/images/visit/location2.png" alt="拱廳" />
          </div>
          <div class="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.7039034897775!2d121.52647427515826!3d25.044120677809698!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a97b22e1b519%3A0xf343f791f814b79c!2z6I-v5bGx5paH5Ym15ZyS5Y2A5LitM-mkqCAy5qiT5oux5buz!5e0!3m2!1szh-TW!2stw!4v1747304214173!5m2!1szh-TW!2stw" 
              width="600" 
              height="450" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
      
      <div class="location-item">
        <h3>烏梅劇院</h3>
        <div class="content-row">
          <div class="image-container">
            <img src="@/assets/images/visit/location1.png" alt="烏梅劇院" />
          </div>
          <div class="map-container">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3614.668355398362!2d121.52732147515837!3d25.045326577809064!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a964b67e944d%3A0xbfbcd5c5c8f950e2!2z6I-v5bGx54OP5qKF5YqH6Zmi!5e0!3m2!1szh-TW!2stw!4v1747304273631!5m2!1szh-TW!2stw" 
              width="600" 
              height="450" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy" 
              referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </div>
        </div>
      </div>
    </div>
    
    <div class="transportation">
      <h2>🚘 交通方式 Transportation</h2>
      <div class="transport-methods">
        <div class="transport-item">
          <h3>✨ 搭乘捷運</h3>
          <ul>
            <li>忠孝新生站（板南線／新蘆線）：1 號出口步行約 3 分鐘</li>
            <li>善導寺站（板南線）：6 號出口步行約 5 分鐘</li>
          </ul>
        </div>
        
        <div class="transport-item">
          <h3>✨ 自行開車</h3>
          <ul>
            <li>停車場入口處在忠孝東路上；園區提供 24 小時停車服務</li>
            <li>汽車平日每小時 40 元、假日每小時 60 元</li>
            <li>平日 280 元/天、假日 540 元/天</li>
            <li>機車每小時 25 元</li>
          </ul>
        </div>
      </div>
    </div>
    
    <div class="related-links">
      <h2>相關連結 Related Links</h2>
      <div class="links-container">
        <a href="https://ipta.nthu.edu.tw/" target="_blank" class="link-btn">
          <img src="@/assets/images/visit/main1.png" alt="清大藝術學院學士班" class="link-icon">
          <span>清大藝術學院學士班</span>
        </a>
        <a href="https://www.nthu.edu.tw/" target="_blank" class="link-btn">
          <img src="@/assets/images/visit/main3.png" alt="國立清華大學" class="link-icon">
          <span>國立清華大學</span>
        </a>
        <a href="https://www.instagram.com/all.ipta/?igsh=MTJqZnZyMXU0bTNhdA%3D%3D&utm_source=qr#" target="_blank" class="link-btn">
          <img src="@/assets/images/home/ig.jpg" alt="Instagram" class="link-icon">
          <span>Instagram</span>
        </a>
        <a href="https://www.facebook.com/atall.ipta?mibextid=wwXIfr&rdid=Je8AvdW7ymjNoh7j&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F14EkZoFoRux%2F%3Fmibextid%3DwwXIfr#" target="_blank" class="link-btn">
          <img src="@/assets/images/home/fb.png" alt="Facebook" class="link-icon">
          <span>Facebook</span>
        </a>
        <a href="https://www.youtube.com/@IPTA_4th_Graduation_Exhibition" target="_blank" class="link-btn">
          <img src="@/assets/images/visit/yt.png" alt="Youtube" class="link-icon">
          <span>Youtube</span>
        </a>
      </div>
    </div>
    
    <div class="partners">
      <h2>合作單位 Partners</h2>
      <div class="partners-container">
        <!-- 先显示main1.png到main3.png -->
        <div class="partner-item">
          <img src="@/assets/images/visit/main1.png" alt="合作單位 main1" class="partner-logo">
        </div>
        <div class="partner-item">
          <img src="@/assets/images/visit/main2.png" alt="合作單位 main2" class="partner-logo">
        </div>
        <div class="partner-item">
          <img src="@/assets/images/visit/main3.png" alt="合作單位 main3" class="partner-logo">
        </div>
        
        <!-- 然后显示logo0.png到logo12.png -->
        <div class="partner-item" v-for="index in 13" :key="index">
          <img :src="require(`@/assets/images/visit/logo${index-1}.png`)" :alt="`合作單位 logo${index-1}`" class="partner-logo">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VisitPage'
}
</script>

<style scoped>
.visit-page {
  padding: 20px;
}

h1 {
  color: #004D6B; /* 蓝色 */
  margin-top: 40px;
  margin-bottom: 20px;
  text-align: center; /* 居中 */
}

.locations {
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin-top: 30px;
  justify-content: space-between;
}

.location-item {
  flex: 1;
  max-width: 48%;
}

.location-item h3 {
  color: rgba(240, 131, 30);
  margin-bottom: 15px;
  text-align: center;
}

.content-row {
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.image-container, .map-container {
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.image-container img {
  width: 100%;
  display: block;
  height: auto;
}

.map-container iframe {
  width: 100%;
  display: block;
  height: 350px;
  aspect-ratio: 1/1;
}

.transportation {
  margin-top: 50px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 8px;
}

.transportation h2 {
  color: #004D6B;
  margin-bottom: 20px;
  text-align: center;
}

.transport-methods {
  display: flex;
  justify-content: space-between;
  gap: 30px;
}

.transport-item {
  flex: 1;
}

.transport-item h3 {
  color: #444;
  margin-bottom: 15px;
}

.transport-item ul {
  list-style-type: none;
  padding-left: 0;
}

.transport-item li {
  margin-bottom: 10px;
  line-height: 1.5;
}

/* 相关链接样式 */
.related-links {
  margin-top: 50px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 8px;
}

.related-links h2 {
  color: #004D6B;
  margin-bottom: 30px;
  text-align: center;
}

.links-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
}

.link-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: white;
  color: #004D6B;
  border-radius: 15px;
  font-weight: bold;
  transition: all 0.3s;
  text-decoration: none;
  box-shadow: 
    4px 4px 8px rgba(0, 0, 0, 0.3),
    -2px -2px 6px rgba(255, 255, 255, 0.8);
  position: relative;
  overflow: hidden;
  padding: 10px;
}

.link-icon {
  width: 70px;
  height: 70px;
  object-fit: contain;
  border-radius: 10px;
  margin-bottom: 8px;
}

.link-btn span {
  font-size: 14px;
  text-align: center;
}

.link-btn:hover {
  background-color: white;
  transform: translateY(-2px);
  box-shadow: 
    6px 6px 10px rgba(0, 0, 0, 0.4),
    -3px -3px 8px rgba(255, 255, 255, 0.9);
}

.link-btn:active {
  transform: translateY(1px);
  box-shadow: 
    2px 2px 4px rgba(0, 0, 0, 0.2),
    -1px -1px 3px rgba(255, 255, 255, 0.7);
}

/* 合作單位樣式 */
.partners {
  margin-top: 50px;
  padding: 20px;
  background-color: #f8f8f8;
  border-radius: 8px;
}

.partners h2 {
  color: #004D6B;
  margin-bottom: 30px;
  text-align: center;
}

.partners-container {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 25px;
}

.partner-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 150px;
  height: 150px;
  background-color: white;
  border-radius: 15px;
  transition: all 0.3s;
  box-shadow: 
    4px 4px 8px rgba(0, 0, 0, 0.3),
    -2px -2px 6px rgba(255, 255, 255, 0.8);
  padding: 15px;
}

.partner-logo {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.partner-item:hover {
  transform: translateY(-2px);
  box-shadow: 
    6px 6px 10px rgba(0, 0, 0, 0.4),
    -3px -3px 8px rgba(255, 255, 255, 0.9);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .content-row {
    flex-direction: column;
  }
  
  .links-container {
    gap: 15px;
  }
  
  .partner-item {
    width: 130px;
    height: 130px;
  }
}

@media (max-width: 768px) {
  .locations {
    flex-direction: column;
  }
  
  .location-item {
    max-width: 100%;
  }
  
  .link-btn {
    width: 100px;
    height: 100px;
  }
  
  .link-icon {
    width: 60px;
    height: 60px;
  }
  
  .link-btn span {
    font-size: 12px;
  }
  
  .partner-item {
    width: 100px;
    height: 100px;
    padding: 10px;
  }
}
</style>

